import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export type CardPickupSettings = {
  cardPickupFineEnabled: boolean;
  cardPickupFineDays: number;
  cardPickupFineAmount: number;
};

type CardPickupSectionProps = {
  settings: CardPickupSettings;
  onChange: (next: CardPickupSettings) => void;
  disabled?: boolean;
};

export function CardPickupSection({ settings, onChange, disabled }: CardPickupSectionProps) {
  return (
    <div className="space-y-5">
      <div className="rounded-lg border border-slate-200 bg-slate-50/60 px-4 py-3">
        <div className="flex items-center gap-2">
          <Checkbox
            id="fineEnabled"
            checked={settings.cardPickupFineEnabled}
            disabled={disabled}
            onCheckedChange={(checked) =>
              onChange({ ...settings, cardPickupFineEnabled: checked === true })
            }
          />
          <Label htmlFor="fineEnabled" className="cursor-pointer font-medium">
            Enable late pickup fines
          </Label>
        </div>
        <p className="mt-1.5 pl-6 text-sm text-slate-500">
          When disabled, missed deadlines expire the card without charging a fine.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="pickupDays">Pickup deadline (days)</Label>
          <Input
            id="pickupDays"
            type="number"
            min={1}
            disabled={disabled}
            value={settings.cardPickupFineDays}
            onChange={(e) =>
              onChange({ ...settings, cardPickupFineDays: parseInt(e.target.value) || 7 })
            }
          />
          <p className="text-xs text-slate-500">Days to pick up after the card is ready.</p>
        </div>
        <div className="flex flex-col gap-1.5">
          <Label
            htmlFor="fineAmount"
            className={!settings.cardPickupFineEnabled ? "text-slate-400" : undefined}
          >
            Late fine amount (₦ / day)
          </Label>
          <div className="relative">
            <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
              ₦
            </span>
            <Input
              id="fineAmount"
              type="number"
              min={0}
              step={0.01}
              disabled={disabled || !settings.cardPickupFineEnabled}
              value={settings.cardPickupFineAmount}
              onChange={(e) =>
                onChange({
                  ...settings,
                  cardPickupFineAmount: parseFloat(e.target.value) || 0,
                })
              }
              className="pl-8"
            />
          </div>
          <p className="text-xs text-slate-500">Charged per day after the pickup deadline.</p>
        </div>
      </div>
    </div>
  );
}
